import { Typography } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import { ChevronRight, Plus } from 'mdi-material-ui'
import { useEffect, useState } from 'react'
import TableCoupon from 'src/views/coupon/TableCoupon'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogCoupon from '../../views/coupon/DialogCoupon'

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ChevronRight />}
        {...props}
    />
  ))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    }
}));

const CouponList = () => {
    const [reload, setReload] = useState(0)
    const [show, setShow] = useState(false)
    const [couponID, setCouponID] = useState(0)

    useEffect(() => {
        !show && setCouponID(0)
    }, [show])

    useEffect(() => {
        couponID > 0 && setShow(true)
    }, [couponID])

    return (
        <Page title="Coupon">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        쿠폰 발급
                    </Typography>
                    }
                    subtitle={<>
                    <Accordion style={{fontSize: '14px'}}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography>쿠폰 발급방식에 대하여..</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            &#x2022; 다운로드 : 특정 회원그룹에 쿠폰을 제공할 때 사용합니다.<br/>
                            &ensp;설정 후 쿠폰 발급형태에서 회원등급별을 선택하여, 등급을 설정할 수 있습니다. <br/>
                            &ensp;상품 페이지에서 쿠폰을 발급 받을 수 있는 쿠폰 배너가 노출됩니다. <br/>
                            &ensp;또는 마이페이지 &#62; 쿠폰 &#62; 에서 다운로드 가능한 쿠폰을 모두 확인 할 수 있습니다.<br/>
                            &#x2022; 자동발행 : 자동발급 쿠폰에는 회원가입시, 리뷰작성시, 첫 구매완료시, 구매완료시 네 가지 설정이 제공됩니다.<br/>
                            &ensp;구매 완료시는 주문서 상태값이 배송완료일 때 지급됩니다.<br/>
                            &#x2022; 수동발행 : 특정 회원에게만 지급하는 경우에 사용하며, 관리자가 직접 지급해야 합니다.
                        </AccordionDetails>
                    </Accordion>                
                    </>
                    }
                />
                <BoxWrapper>
                    <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >발행</Button>
                </BoxWrapper>
                <DialogCoupon show={show} setShow={setShow} setReload={setReload} couponID={couponID} />
                <Grid item xs={12}>
                    <TableCoupon reload={reload} setReload={setReload} setCouponID={setCouponID} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default CouponList